export class SimilarCandidateDetails {
    jobtitle: { key: string; isMandatory: boolean }[];
    jobcompanyname: { key: string; isMandatory: boolean }[];
    jobindustryname: { key: string; isMandatory: boolean }[];
    pastindustries: { key: string; isMandatory: boolean }[];
    schools: { key: string; isMandatory: boolean }[];
    currentlocation: { key: string; isMandatory: boolean }[];
    skills: { key: string; isMandatory: boolean }[];
    elasticid: string | null;
    companysize: { key: string; isMandatory: boolean }[];
    fullname: string | null;
    totaltenure: number | null;
    linkedinurl: string | null;
    isUploadedFromResume: boolean;
    locationregion: string | null;
    locationcontinent: string | null;
    degrees: { key: string; isMandatory: boolean }[];
    fieldOfStudy: { key: string; isMandatory: boolean }[];
    fromYrsOfExperience: number;
    toYrsOfExperinece: number;
    modal_open_reason?: string = null;

    constructor() {
        this.jobtitle = [];
        this.jobcompanyname = [];
        this.jobindustryname = [];
        this.pastindustries = [];
        this.schools = [];
        this.currentlocation = [];
        this.skills = [];
        this.elasticid = null;
        this.companysize = [];
        this.fullname = null;
        this.totaltenure = null;
        this.linkedinurl = null;
        this.isUploadedFromResume = false;
        this.locationregion = null;
        this.locationcontinent = null;
        this.degrees = [];
        this.fieldOfStudy = [];
        this.fromYrsOfExperience = null;
        this.toYrsOfExperinece = null;
    }
}